export default function halfWidthAlternator(halfWidthModules: NodeListOf<HTMLElement>) {
    const addDataAttributeToRightAlignedHalfWidthModules = () => {
        halfWidthModules.forEach((module, index) => {
            if (index === 0) {
                module.dataset.moduleContentAlignment = 'right';
                return;
            }

            if (halfWidthModules[index - 1]?.dataset.moduleContentAlignment !== 'right') {
                module.dataset.moduleContentAlignment = 'right';
            } else {
                module.dataset.moduleContentAlignment = 'left';
            }
        });
    };
    addDataAttributeToRightAlignedHalfWidthModules();
}
